"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobApplicationPublicSchema = void 0;
const zod_1 = require("zod");
// API verbatim schema (source of truth: apps/api/src/common/schemas.ts)
exports.jobApplicationPublicSchema = zod_1.z.object({
    name: zod_1.z.string().min(2).max(255),
    email: zod_1.z.string().email().max(255),
    phone: zod_1.z.string().min(10).max(50),
    jobId: zod_1.z.string().min(1).max(255),
    coverLetter: zod_1.z.string().max(5000).optional().default(""),
});
//# sourceMappingURL=job-application.js.map